import { render, staticRenderFns } from "./EnglishResumePreview.vue?vue&type=template&id=34fd041f"
import script from "./EnglishResumePreview.vue?vue&type=script&lang=js"
export * from "./EnglishResumePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports